import * as React from 'react';
import { Keywords } from '../../../shared/types/ast';
import { ErrorBoundary } from '../error-boundary';
import { getConfig } from '../../config';
import { useCustomTag } from '../recirc-native-ad/recirc-native-ad';
import { Switch } from '../ad-switch/switch';

export type Props = {
    instanceId: string;
    keywords: Keywords;
};

const RecircBannerAdReact = ({ instanceId, keywords }: Props) => {
    const { pageType, deviceType, vertical } = getConfig();
    const customTag = useCustomTag(instanceId, deviceType, keywords, pageType, [
        'banner',
    ]);

    return (
        <Switch
            placementId={instanceId}
            deviceType={deviceType}
            vertical={vertical}
            pageType={pageType}
            customTag={customTag}
            isRecirc={true}
        />
    );
};

const RecircBannerAdReactWithErrorBoundary = (props: Props) => {
    return (
        <ErrorBoundary fallback={null}>
            <RecircBannerAdReact {...props} />
        </ErrorBoundary>
    );
};
export default RecircBannerAdReactWithErrorBoundary;
